import { render, staticRenderFns } from "./bld-features.vue?vue&type=template&id=952844d2&scoped=true&"
import script from "./bld-features.vue?vue&type=script&lang=js&"
export * from "./bld-features.vue?vue&type=script&lang=js&"
import style0 from "./bld-features.vue?vue&type=style&index=0&id=952844d2&lang=scss&scoped=true&"
import style1 from "./bld-features.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952844d2",
  null
  
)

export default component.exports